// Where the web offers the app: the site, whose beta sign-up stands in for
// the store listings until they're public.
export const APP_URL = "https://cloudloop.io";
